import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, withText } from 'preact-i18n';
import { route } from 'preact-router';

@withText(() => ({
    saveText: <Text id='article.save'>Save</Text>,
    unsaveText: <Text id='article.unsave'>Remove from saved</Text>,
}))
@observer
class SaveButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saved: Boolean(props.saved),
            saving: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved !== this.props.saved && !this.state.saving) {
            this.setState({ saved: Boolean(nextProps.saved) });
        }
    }

    toggleSaved = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.saving) return;

        const { stores, articleId, hostname, onSavedChange, surface = 'feed', visitId } = this.props;
        const { appState, userStore } = stores;
        if (!userStore.user?.id) {
            route('/login');
            return;
        }

        const previousSaved = this.state.saved;
        const saved = !previousSaved;
        this.setState({ saved, saving: true });
        onSavedChange?.(articleId, saved, { optimistic: true });
        try {
            const response = await util.fetchApi(
                `/api/feedsaves/article/${articleId}`,
                { method: saved ? 'POST' : 'DELETE', publish: false },
                { hostname },
            );
            if (![200, 201].includes(response?.status)) {
                throw new Error(response?.message || 'Save failed');
            }
            this.setState({ saving: false });
            onSavedChange?.(articleId, saved, { confirmed: true });
            appState.addUsageLog({
                type: saved ? 'feed_save' : 'feed_unsave',
                props: {
                    visitId,
                    contentType: 'article',
                    contentId: Number(articleId),
                    surface,
                },
                timestamp: Math.floor(Date.now() / 1000),
            });
        } catch (error) {
            this.setState({ saved: previousSaved, saving: false });
            onSavedChange?.(articleId, previousSaved, { rollback: true });
            appState.addToast({
                type: 'error',
                message: <Text id='article.save-failed'>Could not update saved posts.</Text>,
            }, 4000);
        }
    }

    render() {
        const { saveText, unsaveText } = this.props;
        const { saved, saving } = this.state;
        const label = saved ? unsaveText : saveText;
        return (
            <button
                type='button'
                class='btn btn-link p-0 text-muted'
                aria-pressed={saved ? 'true' : 'false'}
                aria-label={label}
                title={label}
                disabled={saving}
                onClick={this.toggleSaved}
            >
                <i class={`fa-${saved ? 'solid' : 'regular'} fa-bookmark`} />
                <span class='visually-hidden'>{label}</span>
            </button>
        );
    }
}

export default SaveButton;
